// Render donation form
import React from "react";
import BillingAddressFields from "./BillingAddressFields";
import Button from "./Button";
import DonationSelector from "./DonationSelector";
import EmailAddressField from "./EmailAddressField";
import FormActions from "./FormActions";
import FormErrors from "./FormErrors";
import Loader from "./Loader";
import PaymentMethodFields from "./PaymentMethodFields";

const Donate = (props) => {
  return (
    <div className="component-donate">
      <div className="intro">
        <div className="intro-text">
          <h3>Choose an amount —</h3>
        </div>
      </div>
      <DonationSelector>
        <PaymentMethodFields
          savedBilling={props.savedBilling}
          chosenMethod={props.chosenMethod}
          handleChosenMethodSaved={props.handleChosenMethodSaved}
          handleChosenMethodNew={props.handleChosenMethodNew}
        />
        <ul className="contribute-details">
          <li>
            <a href="#alternatives" className="detail-link">
              Donate by wire, ACH, stock, or cryptocurrency
            </a>
          </li>
          <li>
            <a href="#mail" className="detail-link">
              Donate by mail
            </a>
          </li>
          <li>
            Need help?{" "}
            <a href="mailto:donate@longnow.org" target="_blank" rel="noopener">
              Contact us at donate@longnow.org
            </a>
          </li>
        </ul>

        <EmailAddressField />
        <BillingAddressFields />
        {props.formError && <FormErrors message={props.formError} />}
        <FormActions>
          <Button action="donate" ref={props.submit} />
          <Loader ref={props.loader} />
          <div className="contribute-details">
            Ask your company to match your gift and multiply your impact!
          </div>
        </FormActions>
      </DonationSelector>
    </div>
  );
};
export default Donate;
